<template>
  <fragment>
    <v-row>
      <v-col>
        <v-tabs
          v-model="$ticketPackage.productTab"
          color="#353535"
          class="rounded-t-lg"
        >
          <v-tab
            v-for="item in items"
            :key="item.tab"
            :disabled="tabIsDisabled(item.value)"
          >
            {{ item.tab }}
          </v-tab>
          <v-tooltip
            top
            class="ml-0 pl-n10"
            v-if="disableActions"
            color="black"
          >
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="ml-1 mt-3">
                <InfoIcon size="small" />
              </span>
            </template>
            <span>{{ packageInfo }}</span>
          </v-tooltip>
        </v-tabs>
        <v-tabs-items
          v-model="$ticketPackage.productTab"
          class="py-4 rounded-b-lg"
        >
          <v-tab-item class="px-4">
            <v-row>
              <v-col cols="12" sm="4" md="3">
                <BaseTextField
                  :label="$t('sales.ticket_costumer')"
                  required
                  :placeholder="$t('sales.ticket_costumer_placeholder')"
                  v-model="$ticketPackage.cadastro.consumidor"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <BaseTextField
                  :label="$t('sales.ticket_email')"
                  required
                  placeholder="email@email.com"
                  v-model="$ticketPackage.cadastro.email"
                  type="text"
                  name="email"
                  :rules="[rules.email]"
                />
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <BaseTextField
                  :placeholder="$t('sales.ticket_cellphone_placeholder')"
                  v-model="$ticketPackage.cadastro.celular"
                  :label="$t('sales.ticket_cellphone')"
                  required
                  type="text"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  :rules="[rules.required, rules.cellphone]"
                >
                </BaseTextField>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <BaseTextField
                  tabindex="2"
                  :label="$t('sales.ticket_discount')"
                  placeholder="0"
                  v-model="$ticketPackage.cadastro.desconto"
                  type="number"
                  prefix="%"
                  min="1"
                  max="99"
                />
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <BaseSelect
                  :label="$t('sales.ticket_payment_methods')"
                  :placeholder="$t('sales.ticket_payment_methods_placeholder')"
                  v-model="$ticketPackage.cadastro.metodo_pagamento"
                  :items="$ticketPackage.paymentMethods"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <PackagePreview />
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item class="px-4">
            <v-row>
              <v-col cols="12" sm="4" md="3">
                <BaseTextField
                  :label="$t('sales.ticket_costumer')"
                  required
                  :placeholder="$t('sales.ticket_costumer_placeholder')"
                  v-model="$ticketPackage.cadastro.consumidor"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <BaseTextField
                  :label="$t('sales.ticket_email')"
                  required
                  placeholder="email@email.com"
                  v-model="$ticketPackage.cadastro.email"
                  type="text"
                  name="email"
                  :rules="[rules.email]"
                />
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <BaseTextField
                  :placeholder="$t('sales.ticket_cellphone_placeholder')"
                  v-model="$ticketPackage.cadastro.celular"
                  :label="$t('sales.ticket_cellphone')"
                  required
                  type="text"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  :rules="[rules.required, rules.cellphone]"
                >
                </BaseTextField>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <PackagePreview />
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </fragment>
</template>
<script>
import { mapGetters } from "vuex";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import PackagePreview from "@/components/vendas/PackagePreview.vue";
import InfoIcon from "../icons/InfoIcon.vue";
import mixins from "@/mixins";
const { formRules } = mixins;
export default {
  name: "PackageForm",
  mixins: [formRules],
  components: {
    BaseTextField,
    BaseSelect,
    PackagePreview,
    InfoIcon,
  },
  data() {
    return {
      packageInfo:
        this.$t('sales.ticket_package_info'),
      tab: null
    };
  },
  computed: {
    ...mapGetters(["storeInfo"]),
    items() {
      return [
        { tab: this.$t('sales.direct_selling'), value: "DIRETA" },
        { tab: this.$t('sales.courtesy'), value: "CORTESIA" },
      ]
    },
    disableActions() {
      return this.verifyPackageTax == true;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    verifyPackageTax() {
      return (
        this.storeInfo?.aplica_taxa_pacote == 0 ||
        (this.storeInfo?.aplica_taxa_gratuidade == 0 &&
          this.storeInfo?.aplica_taxa_cortesia == 0)
      );
    },
    isAPaidPackage() {
      return this.$ticketPackage.cadastro.status === "PA";
    },
    consumidorFiltred() {
      const packagePermission = this.$loja_consumidor.consumidores.filter(
        item => item.permite_pacote === 1
      );

      packagePermission.forEach(item => {
        item.nome = item.nome || item.razao_social;
      });

      return packagePermission;
    },
  },
  methods: {
    tabIsDisabled(tabValue) {
      const pacote = this.storeInfo?.aplica_taxa_pacote;
      const gratuidade = this.storeInfo?.aplica_taxa_gratuidade;
      const cortesia = this.storeInfo?.aplica_taxa_cortesia;
      if (tabValue === "DIRETA") {
        return pacote == 0;
      } else if (tabValue === "CORTESIA") {
        return cortesia == 0 && gratuidade == 0;
      } else if (tabValue === "CORTESIA" && tabValue === "DIRETA") {
        return this.$ticketPackage.reservedPackageContentPreview.length > 0;
      }
      return false;
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      return str.replace(/[^a-z0-9]/gi, "");
    },
    search(array, search) {
      let research = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let keyword = this.replaceSpecialChars(
        array.nome.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (keyword.indexOf(research) != -1) {
        return array;
      }
    },
  },
};
</script>

<style>
.info-tool {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50px;
  margin-left: 0.625rem;
  cursor: pointer;
}
</style>
